module.exports = __webpack_public_path__ + "static/media/class_small_druid.b2cf4d40.png";